import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Papa from 'papaparse';
import raw_it from './artworks_it.csv';
import raw_en from './artworks_en.csv';
import { RotatingLines } from "react-loader-spinner";
import { useTranslation } from "react-i18next";


const App = () => {
  const [data, setData] = useState([]);
  const [province, setProvince] = useState('');
  const [uniqueProvinces, setUniqueProvinces] = useState([]);
  const [artista, setArtista] = useState('');
  const [uniqueArtisti, setUniqueArtisti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterType, setFilterType] = useState("topN");
  const [filterValue, setFilterValue] = useState("");
  const { t, i18n } = useTranslation();
  const lang = i18n.language.startsWith("it") ? "it" : "en";


  useEffect(() => {


    fetch(lang === "it" ? raw_it:raw_en)
      .then(response => response.text())
      .then(csv => {
        Papa.parse(csv, {
          header: true,
          complete: (results) => {
            setData(results.data);
            const provinces = [...new Set(results.data.map(item => item.Provincia))];
            setUniqueProvinces(provinces.sort());
            const artisti = [...new Set(results.data.map(item => item.Artista))];
            setUniqueArtisti(artisti.sort());
            setLoading(false);
          }
        });
      });
  }, []);

  

  const handleProvinceChange = (event) => {
    setProvince(event.target.value);
  };

  const handleArtistaChange = (event) => {
    setArtista(event.target.value);
  };

  const filterData = () => {
    if (filterType === "topN") {
      return data
        .sort((a, b) => b["Artista"] - a["Artista"])
        .slice(0, parseInt(filterValue, 10) || 10);
    }
    if (filterType === "byArtista") {
      return data.filter(item =>
        (item.Artista === artista)
      );
    }
    if (filterType === "byProvincia") {
      return data.filter(item => 
        (item.Provincia === province) 
      );
    }
    return data;
  };

  const generateGoogleSearchUrl = (title, author) => {
    const query = encodeURIComponent(`${title} ${author} site:${lang}.wikipedia.org`);
    return `https://www.google.com/search?q=${query}`;
  };

  return (
    <div className="container-fluid">
      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <button class="btn btn-info" onClick={() => i18n.changeLanguage("en")}>🇬🇧 English</button>
          <button class="btn btn-primary" onClick={() => i18n.changeLanguage("it")}>🇮🇹 Italiano</button>
      </div>
      <h1 className="text-center text-primary">{t("title_app")}</h1>
      <p className="text-center text-secondary">Giotto, Caravaggio, Raffaello, Tiziano, Michelangelo, Botticelli, Modigliani</p>
      
      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <RotatingLines
            strokeColor="grey"
            strokeWidth="5"
            animationDuration="0.75"
            width="96"
            visible={true}
          />
         </div>
      ) : (
      <div>
        <div>
        <div className='form-check'>
        <label className="form-check-label">
          <input className="form-check-input"
            type="radio"
            name="filter"
            value="topN"
            checked={filterType === "topN"}
            onChange={() => setFilterType("topN")}
          />
          {t("first_n")}
        </label>
        </div>
        <div className='form-check'>
        <label className="form-check-label">
          <input className="form-check-input"
            type="radio"
            name="filter"
            value="byProvincia"
            checked={filterType === "byProvincia"}
            onChange={() => setFilterType("byProvincia")}
          />
          {t("search_provincia")}
        </label>
        </div>
        <div className='form-check'>
        <label className="form-check-label">
          <input className="form-check-input"
            type="radio"
            name="filter"
            value="byArtista"
            checked={filterType === "byArtista"}
            onChange={() => setFilterType("byArtista")}
          />
          {t("search_artista")}
        </label>
        </div>
      </div>
      {filterType === "topN" && (
        <label className="input-group-text">
        <input 
          type="number"
          placeholder={t("insert_n")}
          value={filterValue}
          onChange={(e) => setFilterValue(e.target.value)}
        />
        </label>
      )}
      {filterType === "byProvincia" && (
        <label className="input-group-text">
        {t("select_provincia")}
        <select 
          value={province} onChange={handleProvinceChange}>
          
          {uniqueProvinces.map(prov => (
            <option key={prov} value={prov}>{prov}</option>
          ))}
        </select>
      </label>
      )}
      {filterType === "byArtista" && (
        <label className="input-group-text">
        {t("select_artista")}
        <select
          value={artista} onChange={handleArtistaChange}>

          {uniqueArtisti.map(prov => (
            <option key={prov} value={prov}>{prov}</option>
          ))}
        </select>
      </label>
      )}
        <div>


        
      </div>
      <table className="table table-striped" >
        <thead>
          <tr>
            <th>{t("search_header")}</th>
            <th>{t("artist")}</th>
            <th>{t("title")}</th>
            <th>{t("year")}</th>
            <th>{t("tecnica")}</th>
            <th>{t("dimensioni")}</th>
            <th>{t("provincia")}</th>
            <th>{t("galleria")}</th>
            
          </tr>
        </thead>
        <tbody>
          {filterData().map((item, index) => (
            <tr key={index}>
              <td>
                  <a
                    href={generateGoogleSearchUrl(item.Titolo, item.Artista)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("search")}
                  </a>
              </td>
              <td>{item.Artista}</td>
              <td>{item.Titolo}</td>
              <td>{item.Anno}</td>
              <td>{item.Tecnica}</td>
              <td>{item.Dimensioni}</td>
              <td>{item.Provincia}</td>
              <td>{item.Galleria}</td>
            </tr>
          ))}
        </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default App;
